import { render, staticRenderFns } from "./audioModule.vue?vue&type=template&id=3f2c6693&scoped=true"
import script from "./audioModule.vue?vue&type=script&lang=js"
export * from "./audioModule.vue?vue&type=script&lang=js"
import style0 from "./audioModule.vue?vue&type=style&index=0&id=3f2c6693&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2c6693",
  null
  
)

export default component.exports